import React from 'react'
import PropTypes from 'prop-types'
import './feature-section.css'

const FeatureSection = (props) => {
  const {
    variant = 'white',
    layout = 'left-right',
    subtitle,
    title,
    description,
    buttonText,
    buttonHref,
    imageSrc,
    imageAlt,
    children,
    className = '',
    ...rest
  } = props

  const sectionClass = `feature-section ${variant === 'grey' ? 'feature-section-grey' : 'feature-section-white'} ${className}`
  const containerClass = layout === 'centered' ? 'feature-section-centered-container' : 'feature-section-container'
  const contentClass = layout === 'right-left' ? 'feature-section-content-reverse' : 'feature-section-content'

  return (
    <section className={sectionClass} {...rest}>
      <div className={containerClass}>
        <div className={contentClass}>
          <div className="feature-section-text">
            {subtitle && <span className="sub-title">{subtitle}</span>}
            {title && <h2 className="title">{title}</h2>}
            {description && (
              <div className="feature-section-description">{description}</div>
            )}
            {children}
            {buttonText && buttonHref && (
              <a
                href={buttonHref}
                target="_blank"
                rel="noreferrer noopener"
                className="feature-section-link"
              >
                <div className="feature-section-button template-button">
                  <span>{buttonText}</span>
                </div>
              </a>
            )}
          </div>
          {imageSrc && (
            <div className="feature-section-image-container">
              <img
                alt={imageAlt || 'Feature image'}
                src={imageSrc}
                className="feature-section-image"
              />
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

FeatureSection.defaultProps = {
  variant: 'white',
  layout: 'left-right',
  subtitle: '',
  title: '',
  description: '',
  buttonText: '',
  buttonHref: '',
  imageSrc: '',
  imageAlt: '',
  className: '',
}

FeatureSection.propTypes = {
  variant: PropTypes.oneOf(['white', 'grey']),
  layout: PropTypes.oneOf(['left-right', 'right-left', 'centered']),
  subtitle: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  buttonText: PropTypes.string,
  buttonHref: PropTypes.string,
  imageSrc: PropTypes.string,
  imageAlt: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
}

export default FeatureSection
